export default "__VITE_ASSET__BA7ESvW$__"